import Vue from 'vue'
import App from '~/App.vue'

import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
let token: any = document.head.querySelector('meta[name="csrf-token"]')
if (token && token?.content) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
}

import '~/plugins/fontawesome'

import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import i18n from './plugins/vue-i18n'

Vue.config.productionTip = true

new Vue({
    store,
    router,
    vuetify,
    i18n,
    el: '#app',
    render: h => h(App),
})
